import React, { useState, useEffect } from 'react';

import messages from './messages';
import axios from 'axios';
import TOCListWithFilters from "./toc/TOCListWithFilters";
import SearchBar from './search/SearchBar';

function alterTableData(stadat, frCode) {
  stadat.tables = stadat.tables.filter(x => x.relatedFirstReleases.includes(frCode));
  for (let t of stadat.tables) {
    if (t.updatedAt) {
      t.updatedAt = new Date(t.updatedAt);
    }
    if (t.correctedAt) {
      t.correctedAt = new Date(t.correctedAt);
    }
    if (t.updateDates) {
      t.updateDates = t.updateDates.map(d => new Date(d));

      const dt = Math.min.apply(null, t.updateDates.filter(d => d > t.updatedAt));
      if (dt !== Infinity) {
        t.nextUpdate = new Date(dt);
      }
    }
  }
  return stadat;
}

const loadingData = (lang) => (
  <h3 style={{ textAlign: 'center', paddingTop: '50px' }}><p>{messages[lang].loadingData}</p></h3>
);

const mgh = "aáeéiíoóöőuúüű".split("");
const aaz = szo => mgh.includes(szo.substring(0, 1).toLowerCase()) ? "az" : "a";
const AAz = szo => mgh.includes(szo.substring(0, 1).toLowerCase()) ? "Az" : "A";

export default function TOC({ frCode, lang }) {
  const frCodeToThemeCode = {
    nep: ['nep'],
    fog: ['mun'],
    mun: ['mun'],
    ker: ['mun'],
    lak: ['lak'],
    gde: ['gdp'],
    gdp: ['gdp'],
    ber: ['ber'],
    kue: ['kkr'],
    kul: ['ara', 'kkr'],
    szk: ['kkr'],
    far: ['ara'],
    krm: ['gdp'],
    mgt: ['mez'],
    ipe: ['ipa'],
    ipa: ['ipa'],
    tar: ['ara'],
    epi: ['ara', 'epi'],
    kis: ['bel'],
    ksz: ['tur'],
  };

  const { REACT_APP_TOC_BASEURL } = process.env;
  const themeCodes = frCodeToThemeCode[frCode];
  const themeCodesStr = themeCodes.join('|');
  const [data, setData] = useState({ meta: { version: 0 }, tables: [] });

  useEffect(() => {
    const result = Promise.all(themeCodes.map(themeCode => axios(`${REACT_APP_TOC_BASEURL}/${themeCode}/toc.json`)));

      result.then(d => {
        const tables = [];
        for (const e of d) {
          Array.prototype.push.apply(tables, e.data.tables);
        }
        setData(alterTableData({tables}, frCode));
      }, console.error);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themeCodesStr]); //  EZ ÍGY A PROPER MOST. NE NYÚJL HOZZÁ, CSAK HA KIJAVÍTOD ÉS ALAPOSAN TESZTELED, hogy nem lép VÉGTELEN CIKLUSBA A HTT QUERY.

  const trans = messages[lang];
  const pageTitle = trans.firstReleaseTOCTitle
    .replace('%title%', trans.firstReleases[frCode])
    .replace('%aaz-title%', aaz(trans.firstReleases[frCode]))
    .replace('%AAz-title%', AAz(trans.firstReleases[frCode]));

  return (
    <React.Fragment>
      <h1 id="content-title">{pageTitle}</h1>
      <SearchBar {...{lang}} />
      <h3>{trans.filterTitle}</h3>
      { data.tables[0] ? <TOCListWithFilters tables={data.tables} lang={lang} showRelatedFirstReleases={false} /> : loadingData(lang) }
    </React.Fragment>
  );
};
